import { IGetAllTreinamentoFuncionarioLocalUseCase } from "../../../presentation/useCases/read/get_all_treinamento_funcionario_local_use_case";
import { TreinamentoFuncionarioLocal } from "../../models/treinamento_funcionario_local";
import { IRhRepository } from "../../repositories/rh_repository";

import dayjs from "dayjs";

/**
 * GetAllTreinamentoFuncionarioLocalUseCase
 */

export class GetAllTreinamentoFuncionarioLocalUseCase implements IGetAllTreinamentoFuncionarioLocalUseCase {
  constructor(private readonly repository: IRhRepository) { }

  async getAllTreinamentoFuncionarioLocal(
    data: Date,
    instrutor: string,
  ): Promise<TreinamentoFuncionarioLocal[]> {
    return await this.repository
      .getAllTreinamentoFuncionarioLocal(dayjs(data).format('YYYYMMDD'), instrutor);
  }
}
